import { FeatureWindowPresentation } from '../Map.types';

export default function FeatureInfoPresentationSelector(props: {
    id: string,
    currentPresentation: FeatureWindowPresentation,
    onPresentationChange: (presentation: FeatureWindowPresentation) => void,
}) {
    return (
        <div className="form-check">
            <div>
                <label className="form-check-label" htmlFor={`${props.id}-fi-one`}>One (only the latest point is shown)</label>
                <input className="form-check-input" type="radio" name={`${props.id}-fiPresentation`} id={`${props.id}-fi-one`}
                    defaultChecked={props.currentPresentation === FeatureWindowPresentation.ONE} onClick={() => props.onPresentationChange(FeatureWindowPresentation.ONE)} />
            </div>
            <div>
                <label className="form-check-label" htmlFor={`${props.id}-fi-list`}>List (keeps a history of points)</label>
                <input className="form-check-input" type="radio" name={`${props.id}-fiPresentation`} id={`${props.id}-fi-list`}
                    defaultChecked={props.currentPresentation === FeatureWindowPresentation.LIST} onClick={() => props.onPresentationChange(FeatureWindowPresentation.LIST)} />
            </div>
            <div>
                <label className="form-check-label" htmlFor={`${props.id}-fi-windows`}>Windows (new window for each feature)</label>
                <input className="form-check-input" type="radio" name={`${props.id}-fiPresentation`} id={`${props.id}-fi-windows`}
                    defaultChecked={props.currentPresentation === FeatureWindowPresentation.WINDOWS} onClick={() => props.onPresentationChange(FeatureWindowPresentation.WINDOWS)} />
            </div>
        </div>
    );
}
